<div class="container">
    <p class="font-14 grey-color text-center-align">
      You’ll need to enter your PIN to send remote commands in the HondaLink app
    </p>
  
    <div class="row">
      <div class="col-sm-4" [formGroup]="subsForm">
        <div class="form-group" formGroupName="pinDetails">
          <label class="text-color">Enter New PIN</label>
          <input type="password" maxlength="4" ondrop="return false;" onpaste="return false;" class="form-control"
            placeholder="Enter 4-digit PIN" formControlName="newPin" />
          <matt-error class="font-12 red-color"
            *ngIf="subsForm.get('pinDetails.newPin')?.hasError('isSequence') && subsForm.get('pinDetails.newPin')?.value?.length==4">
            Pin should not be in forward or backward sequence
          </matt-error>
          <matt-error class="font-12 red-color" *ngIf="subsForm.get('pinDetails.newPin')?.hasError('isSame')">
            Pin should not be identical digits
          </matt-error>
          <matt-error class="font-12 red-color" *ngIf="subsForm.get('pinDetails.newPin')?.hasError('isAlpha')">
            Pin should not have alphabets or special characters
          </matt-error>
        </div>
        <div class="form-group" formGroupName="pinDetails">
          <label class="text-color">Confirm PIN</label>
          <input type="password" maxlength="4" ondrop="return false;" onpaste="return false;"
            placeholder="Re-enter 4-digit PIN" class="form-control" formControlName="confirmPin" />
          <mat-error class="font-12 red-color" *ngIf="subsForm.get('pinDetails.confirmPin')?.hasError('matchPin')
          && subsForm.get('pinDetails.confirmPin')?.dirty">
            Pins do not match
          </mat-error>
        </div>
      </div>
      <div class="col-sm-4"></div>
      <div class="col-sm-4">
        <div class="container-desc">
          <p class="font-12 text-color font-weight-400">PIN Should:</p>
          <p class="font-12 grey-color font-weight-400">
            Not be a sequence of forward numbers<br />Not be a sequence of
            backward numbers<br />Not have four identical digits
            <br />Not have alphabets or special characters
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="!type" class="container-buttons">
      <button class="danger-btn" (click)="onCancel()" mat-button matStepperPrevious>Cancel</button>
      <button class="primar-btn" mat-button matStepperPrevious>Previous</button>
      <button mat-button class="primar-btn" matStepperNext (click)="createPinSubmitted()"
        [disabled]="subsForm.get('pinDetails')?.invalid ?? true">
        Next
      </button>
    </div>
    <div *ngIf="type" class="container-buttons-wv flex-column-wv">
      <!-- <button class="button-with-radius" (click)="onCancel()" mat-button matStepperPrevious>
        Cancel
      </button> -->
      <button mat-button class="button-with-radius" matStepperNext (click)="createPinSubmitted()"
        [disabled]="subsForm.get('pinDetails')?.invalid ?? true">
        Next
      </button>
      <button class="button-wv" mat-button matStepperPrevious>
        Previous
      </button>
    </div>
  </div>